import { Container } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Fade from '@mui/material/Fade';
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { useGetUnitsByAccountQuery } from '../../../api/recalc/endpoints/unitsApiSlice';
import { getSelectedAccount } from '../../../redux/selectedAccountSlice';

import UnitDataGrid from '@/features/devices/components/units/UnitDataGrid';

const UnitsPage = () => {
  const selectedAccount = useSelector(getSelectedAccount);
  const {
    data: units,
    error,
    isLoading,
    isSuccess,
  } = useGetUnitsByAccountQuery(selectedAccount?.AccountId, {
    skip: !selectedAccount?.AccountId,
  });

  return (
    <Container maxWidth="xxl">
      <Suspense
        fallback={
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '80vh',
              verticalAlign: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        }
      >
        {isLoading ? (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '80vh',
              verticalAlign: 'center',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Fade in={isSuccess} timeout={500}>
            <Box>
              <UnitDataGrid
                accountId={selectedAccount?.AccountId}
                units={units}
                isLoading={isLoading}
              />
            </Box>
          </Fade>
        )}
      </Suspense>
    </Container>
  );
};

export default UnitsPage;
